import { Directive, ElementRef, Renderer, OnInit } from "@angular/core";

@Directive({ selector: '[setFocus]' })

export class FocusDirective implements OnInit {
    constructor(private el: ElementRef, private renderer: Renderer) {
        // focus won't work at construction time - too early
    }

    ngOnInit() {
        setTimeout(_ => this.renderer.invokeElementMethod(this.el.nativeElement, 'focus', []));
    }
}
